import { Directive, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[sm-full-width]' })
export class SalonMonsterFullWidthDirective {
    constructor(el: ElementRef) {
     el.nativeElement.style.width = '100%';
    }
}